import Box from '@mui/material/Box';
import {
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ScheduledMessageCard } from 'components';
import { motion } from 'framer-motion';

import * as S from './styles';

interface ScheduledMessage {
  id: string;
  avatar?: string;
  name: string;
  preview: string;
  sendAt: string | Date;
  isError?: boolean;
  errorStatus?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  messages: ScheduledMessage[];
  onDeleteScheduledMessage: (id: string, sendAt: string | Date) => Promise<void>;
  onRescheduleScheduledMessage: (props: { id: string; newSendAt: string | Date; message: string }) => Promise<void>;
  onEditScheduledMessage: (props: { id: string; newSendAt: string | Date; message: string }) => Promise<void>;
  onRetryScheduledMessage: (props: { id: string; sendAt: string | Date; message: string }) => Promise<void>;
  onSendScheduledMessage: (props: { id: string; sendAt: string | Date; message: string }) => Promise<void>;
}

export default function ScheduledMessagesDrawer({
  open,
  onClose,
  messages,
  onDeleteScheduledMessage,
  onRescheduleScheduledMessage,
  onEditScheduledMessage,
  onRetryScheduledMessage,
  onSendScheduledMessage,
}: Props) {
  if (!open) return null;

  return (
    <S.ScheduledMessagesDrawerContainer>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        borderBottom="1px solid #E0E0E0"
      >
        <Typography variant="subtitle1" fontWeight="bold">
          Mensagens agendadas
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <S.ScheduledMessages>
        {messages.map((msg, index) => (
          <motion.div
            key={msg.id}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.3,
              delay: 0.05 * index,
              ease: 'easeOut',
            }}
          >
            <ScheduledMessageCard
              onRetry={async () =>
                await onRetryScheduledMessage({
                  id: msg.id,
                  sendAt: msg.sendAt,
                  message: msg.preview,
                })
              }
              userName={msg.name}
              userAvatarUrl={msg.avatar}
              scheduledTime={msg.sendAt}
              message={msg.preview}
              id={msg.id}
              onEdit={onEditScheduledMessage}
              onReschedule={onRescheduleScheduledMessage}
              onSend={onSendScheduledMessage}
              isError={msg.isError}
              errorStatus={msg.errorStatus}
              onDelete={async () => await onDeleteScheduledMessage(msg.id, msg.sendAt)}
            />
          </motion.div>
        ))}
      </S.ScheduledMessages>
    </S.ScheduledMessagesDrawerContainer>
  );
}
